export const APIConfig = {
  baseUrl: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  crossDomain: true,
  contentType: false,
  responseType: "json",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};
